module.exports = __webpack_public_path__ + "static/jasrac-15be99aaa0c145adcddff2a221ac1e2f.jpg";